import { useSelector } from "react-redux";
import useSwr from "swr";
import { isAuthenticatedSelector } from "../components/login/logic/actions";
import envconfig from "../envconfig";
import apiImportService from "../services/apiImportService";

const useGetApiImports = () => {
    const isAuth = useSelector(isAuthenticatedSelector);
    const { data, isLoading, error } = useSwr(
        isAuth ? "count-pending-acceptance" : null,
        apiImportService.countFilmsToAccept,
        {
            refreshInterval: envconfig.API_IMPORT_DEBOUNCE,
        }
    );

    return {
        filmsNoAccepted: data || 0,
        isLoading,
        error,
    };
};

export default useGetApiImports;
